module.exports = __webpack_public_path__ + "static/media/01-PaddockRotation.029a7955.gif";